export default __webpack_public_path__ + "static/media/medicines.b626b193.svg";